function searchPopdown(locale,tree){
    const popdown = window.document.getElementById('search-popdown');
    const emptySearch = window.document.querySelector('[data-search-empty]');
    const results = window.document.querySelector('[data-search-results]');
    let requested = false;
    if (!popdown || !popdown.classList.contains('with-popular')) return;
    
    const observer = new MutationObserver(function (mutationsList) {
        
        if(popdown.classList.contains('is-searched') && requested) {
            if( !emptySearch) return
            const empty = results.querySelectorAll('.search__results__empty')
            if (empty.length > 0)
                emptySearch.style.display = 'block';
            else            
                emptySearch.style.display = 'none';
            return;
        }
        else{
            emptySearch.style.display = 'block';
        }
        if(!popdown.classList.contains('is-visible') || requested) return
        requested = true;
        getMostSearchedCollections(locale,tree);

    })

    observer.observe(popdown, {
    attributes: true, 
    attributeFilter: ['class'],
    childList: false, 
    characterData: false
    })
}